import * as React from 'react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'
import linkResolver from './src/utils/linkResolver'

import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/700.css';
import './src/styles/default.css';

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      { repositoryName: 'apex-group', linkResolver },
    ]}
  >
    {element}
  </PrismicPreviewProvider>
)
